import type { AgentProfileState } from './types'
import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@redux'

import { NAME } from './constant'

export const initialState: AgentProfileState = {
  error: null,
  status: 'initial',
  data: {},
}

export const slice = createSlice(NAME, {
  name: NAME,
  initialState,
  reducers: {
    setAgentProfile(state, action: PayloadAction<AgentProfile>) {
      state.data = action.payload
    },
  },
})

export const reducer = slice.reducer
export * from './selectors'

export const actions = {
  ...slice.actions,
}

export default { [NAME]: slice.reducer }
